module.exports = __webpack_public_path__ + "img/images_homebanner_1_2.297d257e.png";